import styled from 'styled-components';
import WithDirection from '../../library/helpers/rtl';

const AddDepaturePointStyleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 0px 20px;
  .departure-form{
    max-height: 52vh;
    overflow-y: auto;
  }
  .add-destination-form-container {
    margin-top: 20px;

    div {
      width: 100%;
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;
      p {
        min-width: 50%;
        margin: 0px 10px 0px 0px;
        align-self: flex-start;
      }
      .ant-form-item {
        display: flex;
        flex-direction: row;
        width: 100%;
        margin-bottom: 0px;
        .ant-row {
          width: 100%;
          margin-bottom: 0px;
          .ant-col {
            display: flex;
            flex-direction: column;
            margin-bottom: 0px;
            div {
              margin-bottom: 0px;
            }
            .ant-form-item-control-input {
              margin-bottom: 0px;
              width: 100%;
              div {
                margin-bottom: 0px;
              }
              .ant-form-item-control-input-content {
                margin-bottom: 0px;
                .ant-select {
                  margin-bottom: 0px;
                  .ant-select-selector {
                    margin-bottom: 0px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .add-destination-save {
    display: flex;
    margin: 0px auto;
    justify-content: center;
    .ant-btn {
      width: auto;
    }
  }
`;
export default WithDirection(AddDepaturePointStyleWrapper);
